import {useEffect, useState} from "react";
import {v4 as uuidv4} from 'uuid';
import type {IPlanItem} from "./PlanItem";
import PlanItem from "./PlanItem";
import Draggable from "react-draggable";
import DraggableItem from "./DraggableItem";
import {Config, Helpers} from "../utils";


const SCALES = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 2.25];


export default function Plan(props) {
  const [scaleIndex, setScaleIndex] = useState(3);
  const [fullScreen, setFullScreen] = useState(false);


  useEffect(() => {
    if (props.showPlacements) {
      setScaleIndex(3)
    }
  }, [props.showPlacements])


  const addElement = (e) => {
    if (e.target?.id !== 'draggablePlanWrapper')
      return;

    if (props.showPlacements && props.selectedProduct.type.startsWith('panel')) {
      props.addElement(e, SCALES[scaleIndex]);
    }
  }

  const onClickElement = () => {
    // if(props.showPlacements && ['knaga', 'drabinka'].includes(props.selectedProduct.type)) {
    //   console.log('on click on add')
    // }
  }

  const LegendComponent = () => (
    <>
      <h5>Legende</h5>
      <div className="d-flex">
        <div className="me-4">
          <p>
            <span className="badge" style={{backgroundColor: Helpers.getColorByType('barierka')}}>Absperrung</span>
            <br/><span className="badge" style={{backgroundColor: Helpers.getColorByType('deska_okalajaca')}}>Umgebendes Holzbrett</span>
            <br/><span className="badge" style={{backgroundColor: Helpers.getColorByType('listwa_odbojowa')}}>Prell-Leiste</span>
          </p>
        </div>
        <div className="me-4" style={{fontSize: 14}}>
          <div><img src={Helpers.getIconByType('knaga')} alt=""
                    style={{width: 15, height: 15, objectFit: 'contain'}}/> Knagge / T-Poller
          </div>
          <div><img src={Helpers.getIconByType('drabinka')} alt=""
                    style={{width: 15, height: 15, objectFit: 'contain'}}/> Leiter
          </div>
          <div><img src={Helpers.getIconByType('strzalka_trapezowa')} alt=""
                    style={{width: 15, height: 15, objectFit: 'contain'}}/> trapezartiger Fingersteg
          </div>
        </div>
        <div style={{fontSize: 14}}>
          <div><img src={Helpers.getIconByType('strzalka')} alt=""
                    style={{width: 15, height: 15, objectFit: 'contain'}}/> Pfeil
          </div>
          <div><img src={Helpers.getIconByType('slupek_pomoc')} alt=""
                    style={{width: 15, height: 15, objectFit: 'contain'}}/> Hilfs-Pfahl
          </div>
          <div><img src={Helpers.getIconByType('')} alt="" style={{width: 15, height: 15, objectFit: 'contain'}}/> Anderes Zusatzteil
          </div>
        </div>
      </div>
      <p style={{fontSize: 14, fontStyle: 'italic'}}>
        Um einen Durchgang im Geländer zu erstellen, klicken Sie darauf und wählen Sie dann die Breite der Aussparung aus.
        <br/> Sie können einen Platz für die Aussparung auswählen, indem Sie eine entsprechende Stelle ziehen.
      </p>
    </>
  )


  return (
    <div>
      <div className={`card plan mb-3 ${fullScreen ? '-fullScreen' : ''}`}>
        <div className={`card-body plan__content`}>

          <div style={{
            position: 'absolute',
            left: document.body.offsetWidth < 500 ? -1500 : -900,
            transform: `scale(${SCALES[scaleIndex]})`,
            transformOrigin: 'center top',
          }}>
            <Draggable
              cancel=".planItem"
            >
              <div id="draggablePlanWrapper"
                   style={{
                     width: 3000,
                     height: 3000,
                     border: '1px solid #cbcbcb',
                     cursor: props.showPlacements ? 'pointer' : undefined,
                   }}
                   onClick={addElement}
                   onTouchStart={addElement}
              >
                {props.elements.map((el, idx) => (
                  <DraggableItem
                    key={el.id}
                    item={el}
                    selectedProduct={props.selectedProduct}
                    showPlacements={props.showPlacements}
                    deletionMode={props.deletionMode}
                    disabled={props.showPlacements}
                    elements={props.elements}
                    scale={SCALES[scaleIndex]}
                    onDelete={() => props.onDelete(el.id)}
                    onClick={onClickElement}
                    cancelActions={props.cancelActions}
                    editCustomElements={customElements => props.editCustomElements(el.id, customElements)}
                  />
                ))}

                <div style={{position: 'absolute', bottom: 0, right: 0, padding: 20}}>
                  <LegendComponent/>
                </div>
              </div>
            </Draggable>
          </div>


        </div>

        <div className="plan__buttons">
          {!!props.showPlacements && (
            <button className="btn btn-info" onClick={props.onEndEditing}>Beenden Sie die Bearbeitung</button>
          )}
          <button
            className={`btn ${props.deletionMode ? 'btn-danger' : 'btn-outline-danger'}`}
            onClick={props.toggleDeletionMode}
          >
            {props.deletionMode ? 'Deaktivieren Sie den Löschmodus' : 'Löschmodus aktivieren'}
          </button>
          <button
            className="btn btn-secondary"
            style={{width: 40}}
            onClick={() => setScaleIndex(old => old < SCALES.length - 1 ? old + 1 : old)}
          >+
          </button>
          <button
            className="btn btn-secondary"
            style={{width: 40}}
            onClick={() => setScaleIndex(old => old > 0 ? old - 1 : old)}
          >-
          </button>
          <button
            className="btn btn-secondary"
            style={{width: 40}}
            onClick={() => setFullScreen(prev => !prev)}
          >
            <img src={require('../assets/img/expand-arrows-alt-solid-white.svg').default} alt=""/>
          </button>
        </div>

      </div>

      <div>
        {props.deletionMode && (
          <p className="badge bg-danger">
            Löschmodus ist an! Klicken Sie auf das ausgewählte Element, um es zu entfernen.
          </p>
        )}
        <LegendComponent/>
      </div>
    </div>
  )
}
